import React, { useContext } from 'react';

import * as S from './styles';

import LineSkeleton from '@/components/Shared/LineSkeleton';

import PaymentLinkContext from '@/pages/Checkout/context/PaymentLinkContext';

const AddressCEPLoading: React.FC = (): JSX.Element => {
  const { loadingCEP } = useContext(PaymentLinkContext);

  return (
    <S.Container>
      {loadingCEP && (
        <>
          <LineSkeleton width="112" height="16px" />
          <LineSkeleton width="100%" height="16px" />
          <LineSkeleton width="100%" height="16px" />
        </>
      )}
    </S.Container>
  );
};

export default AddressCEPLoading;
